package com.narbase.letsgo.web.views.bankilyTransfers

import com.narbase.letsgo.web.models.TransferType
import sd.gov.moe.lp.admin.utils.views.filters.DropListFilter

open class TransferTypeFilter(
    private val onItemSelected: (TransferType?) -> Unit,
) : DropListFilter<TransferType?>(
    "Type",
    "Type",
   TransferType.values().toList().toTypedArray(),
    defaultValue = null,
    valueToString = { it?.name ?: "" },
    onItemSelected = {
        onItemSelected(it)
    }
)

open class AssignmentFilter(
    private val onItemSelected: (Assignment?) -> Unit,
) : DropListFilter<Assignment?>(
    "Assignment",
    "Assignment",
    Assignment.values().toList().toTypedArray(),
    defaultValue = null,
    valueToString = { it?.name ?: "" },
    onItemSelected = {
        onItemSelected(it)
    }
)



enum class Assignment {
    Assigned,
    UnAssigned
}